import React from 'react'

export function useRouter(props) {
  return {
    pathname: props.location.pathname,
    query: {
      artistId: ''
    },
    push: (path) => {
      props.history.push(path)
    }
  }
}
